import {
  Flex,
  Link,
  IconButton,
  Box,
  useDisclosure,
  useMediaQuery,
  Text,
} from "@chakra-ui/react";

import Icon from "../../components/Icon";
import ImageMenu from "./components/ImageMenu";
import CustomDrawer from "../../components/CustomDrawer";
import NotificationButton from "../../components/NotificationButton";
import GuestInsightsDrawer from "./components/GuestInsightDrawer";
import { GuestDrawerStore, onInsightsModal } from "../../utils/guest";
import { useSnapshot } from "valtio";
import MobileNavDrawer from "./components/MobileNavDrawer";
import { useLocation } from "react-router-dom";
import Button from "../../components/Button";
import { ClientStorage, ClientStorageItem } from "../../utils/clientstorage";
import { UserWeddingRole } from "../../types/wedding";
import { Routes } from "../../routes/baseRoutes";
import EnvConfig from "../../config/env.config";
import { editorState } from "../../utils/editor";

const MobileNavigation = () => {
  const { isInsightsModalOpen } = useSnapshot(GuestDrawerStore);
  const { isOpen, onOpen, onClose } = useDisclosure();
  const { weddingID } = useSnapshot(editorState);

  const location = useLocation();

  const [isSmallerThan768] = useMediaQuery("(max-width: 768px)");
  const isWebsiteEditFlow = location.pathname.includes("/website/edit/");

  const userWeddingRole = ClientStorage.fetch<UserWeddingRole>(
    ClientStorageItem.UserWeddingRole
  );

  const isEventPlannerPath = location.pathname.startsWith("/planner/weddings/");
  const isEventPlannerWebsite =
    userWeddingRole === UserWeddingRole.EventPlanner && isEventPlannerPath;

  const basePath = isEventPlannerWebsite
    ? location.pathname.match(/^\/planner\/weddings\/[^/]+/)?.[0] || ""
    : "";

  return (
    <>
      <Box
        as={"header"}
        w={"full"}
        p={"0.5rem 0.5rem"}
        {...(isWebsiteEditFlow ? { border: "1px solid #E2E8F0" } : {})}
      >
        <Flex
          justifyContent={"space-between"}
          alignItems={"center"}
          sx={{ "--button-size": " 1.5rem" }}
        >
          <Flex columnGap={"12px"} alignItems={"center"}>
            <IconButton
              aria-label={"Open Menu"}
              color={"#000"}
              icon={
                !isOpen ? (
                  <Icon name="hamburger" variant="stroke" />
                ) : (
                  <Icon name="close" variant="stroke" />
                )
              }
              isRound={true}
              className="button"
              data-button-variant="icon"
              onClick={!isOpen ? onOpen : onClose}
            ></IconButton>
            <Link href={"/"}>
              <Flex align="center">
                <Box
                  bg={"black"}
                  color="white"
                  borderRadius="full"
                  h="36px"
                  w="36px"
                  display={"flex"}
                  alignItems="center"
                  justifyContent="center"
                >
                  <Text className="dcalligraphy" fontSize="15px">
                    W
                  </Text>
                </Box>
              </Flex>
            </Link>
            {/* <Flex
              display={isSmallerThan420 ? "none" : "flex"}
              align={"center"}
              flexDir={"row"}
              gap={isSmallerThan420 ? 2 : 5}
              h={"46px"}
              px={"0.275rem"}
              ml={{ base: "0.35rem", md: "1.575rem" }}
            >
              <RouteTab
                url={"/guests"}
                isActive={location.pathname === "/guests"}
                tabName="Guests"
              />
            </Flex> */}
          </Flex>
          <Flex
            alignItems={"center"}
            columnGap={"12px"}
            pr={{ base: "0.35rem", md: "0.6rem" }}
          >
            {/* <IconButton
              aria-label="Guest Insight"
              icon={<Icon name="chart" variant="stroke" />}
              className="button"
              data-button-variant="icon"
              onClick={onInsightsModal("open")}
            />
            */}
            {isSmallerThan768 && isWebsiteEditFlow && (
              <Button
                px={{ base: "0.75rem", md: "1.5rem" }}
                py={"0.5rem"}
                h={"1.6875rem"}
                borderRadius={"50px"}
                onClick={() => {}}
                bg={"#000000"}
                fontFamily={"font4"}
                fontWeight={500}
                color={"#FFFFFF"}
                text={"Preview"}
                fontSize={{ base: "0.765rem", md: "1rem" }}
              />
            )}
            <NotificationButton
              size="md"
              badgeClassName="!-right-1.5 !-top-1.5 !h-3.5 !min-w-[14px] px-0.5 !text-[8px] ring-2 ring-[#F9F9F9]"
            />
            <ImageMenu settingsRoute={basePath + Routes.settings} />
          </Flex>
        </Flex>
      </Box>
      <CustomDrawer
        borderTopRadius={false}
        placement={"right"}
        isOpen={isInsightsModalOpen}
        closeOnOverlayClick={isInsightsModalOpen}
        closeOnEsc={isInsightsModalOpen}
        onClose={onInsightsModal("close")}
        h={"full"}
        content={<GuestInsightsDrawer onClose={onInsightsModal("close")} />}
      />
      <MobileNavDrawer
        shouldDisplayCatering={EnvConfig.cateringFeatureList.includes(
          weddingID
        )}
        isOpen={isOpen}
        onClose={onClose}
      />
    </>
  );
};

export default MobileNavigation;
